<template>
  <div id="list">
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <vue-data-loading :loading="loading" :completed="completed" :listens="['infinite-scroll']" :init-scroll="true" @infinite-scroll="infiniteScroll">
      <div class="content" v-for="(item, index) in alist" :key="index">
        <div class="order-shop">
          <div class="shop">
            <span>{{item.store}}</span>
            <i class="iconfont">&#xe60f;</i>
          </div>
          <div class="trade">
            <span>{{item.state}}</span>
          </div>
        </div>
        <div class="order-message" v-for="(pitem, goodsindex) in item.products" :key="goodsindex">
          <div>
            <img :src="pitem.imgUrl ? url + pitem.imgUrl : defaultimg">
          </div>
          <div>
            <p>{{pitem.title}}</p>
          </div>
          <div class="order-price">
            <p>￥{{pitem.price}}</p>
            <p class="num">x{{pitem.num}}</p>
          </div>
        </div>
        <div class="order-total">
          <span class="total">共<span class="data">{{item.totnum}}</span>件商品<span>合计：<span class="data">￥{{item.totprice}}</span></span></span>
          <span class="order_num">订单号：<span class="number">{{item.ordernum}}</span></span>
        </div>
        <div class="order-state">
          <div v-show="item.state === '待付款'">
            <button class="order-pay" @click="handlePayClick(index)">在线支付</button>
            <button class="order-cancel" @click="handleCancelClick(index)">取消订单</button>
          </div>
          <div v-show="item.state === '已发货'">
            <span>此订单已付款，请联系店家取货</span>
            <button class="confirm-receipt">确认收货</button>
          </div>
        </div>
      </div>
      <img class="empty" src="/static/img/mescroll-empty.png" v-show="show">
      <div slot="infinite-scroll-loading">loading...</div>
      <div slot="completed">没有更多订单了~</div>
    </vue-data-loading>
  </div>
</template>

<script>
// 引入上拉加载组件
import VueDataLoading from 'vue-data-loading'
import url from '@/common/common.js'
export default {
  name: 'OrderList',
  props: {
    list: Array
  },
  components: {
    VueDataLoading // 注册VueDataLoading组件
  },
  data () {
    return {
      loading: false,
      completed: false,
      num: 1,
      size: 10,
      alist: [],
      show: false,
      newindex: [], // 临时存放index
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    /* 上拉加载 */
    fetchData () {
      this.loading = true
      this.getOrdeInfo()
    },
    infiniteScroll () {
      this.fetchData()
      this.num++
    },
    getOrdeInfo () {
      // 联网请求
      this.axios.get('/ApiMyOrder/GetList', {
        params: {
          num: this.num, // 页码
          size: this.size
        }
      }).then(this.getOrdeInfoSucc)
        .catch(this.getOrdeInfoFail)
    },
    getOrdeInfoSucc (res) {
      res = res.data
      var newList = this.list
      if (res.ret && res.data) {
        const data = res.data
        // this.list.push(JSON.parse(data.orderList))
        newList = JSON.parse(data.orderList)
        if (newList.length === 0) {
          this.completed = true
          this.loading = false
          this.show = true
        } else {
          for (var i = 0; i < newList.length; i++) {
            setTimeout(() => {
              if (newList[i] <= 10) {
                this.completed = true
                this.loading = false
                return
              }
              const temp = []
              for (let i = newList.length + 1; i <= newList.length + 50; i++) {
                temp.push(i)
              }
              newList = newList.concat(temp)
              this.loading = false
            }, 1000)
            this.alist.push(newList[i])
            // console.log(this.alist)
          }
        }
      }
      // console.log(newList)
    },
    getOrdeInfoFail (err) {
      alert(err)
    },
    /* 立即支付 */
    handlePayClick (index) {
      this.$router.push({
        path: '/identify_verify',
        query: {
          oid: this.alist[index].ordernum,
          id: this.alist[index].orderid
        }
      })
    },
    /* 取消订单 */
    handleCancelClick (index) {
      this.newindex = index
      this.axios.get('/ApiOrderPay/CancelOrder', {
        params: {
          oid: this.alist[this.newindex].orderid
        }
      }).then(this.handleCancelSuccClick)
        .catch(this.handleCancelFailClick)
    },
    handleCancelSuccClick (res) {
      res = res.data
      if (res.errorInfo === '') {
        alert('取消成功')
        this.alist.splice(this.newindex, 1)
      } else {
        alert(res.errorInfo)
      }
    },
    handleCancelFailClick (err) {
      alert(err)
    }
  }
}
</script>

<style scoped>
.vue-data-loading >>>.loading-header{ display: none!important;}
.empty{ display: block; margin: 0 auto; width: 100%;}
.header{ padding: 10px 15px; padding-bottom: 5px;}
.header .iconfont{ font-size: 25px;}
.content{ background-color: #fff; border-top: 10px solid #eff3f6;}
.order-shop,.order-message{ display: flex; justify-content: space-between; font-size: 14px;}
.order-shop{ padding: 7px 15px;}
.order-message{ padding: 10px 15px; background-color: #fafafa; margin-bottom: 10px;}
.trade{ color: #ef622a;}
.shop{ color: #323232;}
.shop .iconfont{ color: #cbcbcb;}
.order-message img{ margin-right: 11px; width: 80px; height: 80px;}
.spec{ color: #949494; margin-top: 5px;}
.num{ color: #9a9a9a; float: right; margin-top: 5px;}
.order-total{ padding: 0 13px; padding-bottom: 10px;}
.total{ float: right;}
.order-total span{ font-size: 14px; color: #313131;}
.order-total span.order_num{ color: #666;}
.order-total span.number{ padding: 0; color: #666;}
.order-price{ margin-left: 8px;}
.order-total .data{ padding: 0;}
.order-state{ display: flex; justify-content: flex-end; padding: 0 15px;}
.order-state button{ background: transparent; border: 0; border-radius: 5px; padding: 5px 10px; margin-left: 8px; margin-bottom: 13px;}
.order-state .order-pay{ border: 1px solid #00b069; color: #00b069;}
.order-state .order-cancel{ border: 1px solid #ef622a; color: #ef622a;}
.order-state .confirm-receipt{ border: 1px solid #f00; color: #f00;}
.order-state span{ color: #f00; height: 31px; line-height: 31px;}
</style>



// WEBPACK FOOTER //
// src/pages/order_form/components/List.vue